import { useQuery } from '@tanstack/react-query'
import { creditsApi } from '~/entities/credits/api/credits'
import { QueryKey, queryKey } from '~/shared/lib/query-keys'

/**
 * Credit balance for a business. Intentionally NOT cached: several operators
 * can be signed into the same business at once, so a cached number would show
 * a stale balance after someone else spends.
 */
export function useCreditsBalance(businessId: string) {
  return useQuery({
    queryKey: queryKey(QueryKey.CREDITS_BALANCE, businessId),
    queryFn: () => creditsApi.getBalance(businessId),
    enabled: !!businessId,
    staleTime: 0,
    gcTime: 0,
    refetchOnMount: 'always',
    refetchOnWindowFocus: true,
  })
}
